import { createRoot } from "react-dom/client";
import { StoreProvider } from "../app/storeProvider";
import React from "react";
import BotbRAFPage from "@/app/(custom-header)/botb-refer-a-friend/page";

const root = createRoot(document.getElementById("botb-raf-container") as HTMLElement);

root.render(
  <React.StrictMode>
    <StoreProvider>
      <BotbRAFPage />
    </StoreProvider>
  </React.StrictMode>
);
